import { render, staticRenderFns } from "./StatSettings.vue?vue&type=template&id=1019f8a2&"
import script from "./StatSettings.vue?vue&type=script&lang=js&"
export * from "./StatSettings.vue?vue&type=script&lang=js&"
import style0 from "./StatSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports